import React from 'react';
import Styled from 'styled-components';
import ForecastTooltip from '../../../forecast-app/shared/components/tooltips/ForecastTooltip';
import {ValueCell} from '../../initial-plan/ValueCell';

const Container = Styled.div`
	display: flex;
	flex-grow: 1
	height: 20px;
	background-color: #e8e8eb;
	align-items: center;
	margin-left: ${props => props.addGroupingPadding && '10px'};
	margin-right: ${props => props.addGroupingPadding && '10px'};
`;

export const PhasesBaselineHeader = ({isInGrouping, targetMinutes, targetPrice, currencySymbol, availableColumns, taskCellMaxWidth, intl}) => {
	const wrapStyle = col => {
		const style = {};
		if (col.maxWidth) {
			style.maxWidth = col.maxWidth;
		} else {
			style.flexGrow = 1;
			style.maxWidth = taskCellMaxWidth;
		}
		if (col.minWidth) {
			style.minWidth = col.minWidth;
		}
		style.textAlign = col.align;
		style.width = col.width;
		return style;
	};

	const getRowElementForColumn = column => {
		if ((column.checked && !column.notAnElem) || column.maintainSpace) {
			switch (column.name) {
				case 'task-name': {
					return (
						<Field align={'left'} style={{...wrapStyle(column), textTransform: 'uppercase', fontWeight: '500', fontSize: '9px', letterSpacing: '1px', paddingLeft: isInGrouping ? '24px' : '0px'}}>
							{intl.formatMessage({id: 'project_section.baseline'})}
						</Field>
					);
				}
				case 'forecast': {
					return (
						<Field align={column.align} style={wrapStyle(column)}>
							<ValueCell type={ValueCell.VALUE_TYPE.TIME} value={targetMinutes / 60}></ValueCell>
						</Field>
					);
				}
				case 'price': {
					return (
						<Field align={column.align} style={wrapStyle(column)}>
							<ValueCell type={ValueCell.VALUE_TYPE.PRICE} value={targetPrice} currencySymbol={currencySymbol} decimals={2}></ValueCell>
						</Field>
					);
				}
				default: {
					return <Field style={wrapStyle(column)}></Field>;
				}
			}
		}
	};

	return (
		<ForecastTooltip content={intl.formatMessage({id: 'baseline.scoping_expense_tooltip'})} followCursor={'initial'}>
			<Container data-userpilot={'phase-baseline-header'} addGroupingPadding={isInGrouping}>
				{!isInGrouping && <div style={{width: '26px', height: '100%;', position: 'relative'}}></div>}
				{availableColumns.map(column => getRowElementForColumn(column))}
			</Container>
		</ForecastTooltip>
	);
};

const Field = Styled.div`
	display: flex;
	white-space: nowrap;
	font-size: 12px;
	height: 100%;
	align-items: center;
	justify-content: ${props => {
		switch (props.align) {
			case 'left':
				return 'flex-start';
			case 'right':
				return 'flex-end';
			case 'center':
				return 'center';
			default:
				return 'center';
		}
	}};
`;
